import * as React from "react";
import { toast as sonnerToast } from "sonner";

type ToastProps = {
    title?: string;
    description?: string;
    variant?: "default" | "destructive";
    duration?: number;
};

export const useToast = () => {
    const toast = React.useCallback((props: ToastProps) => {
        const { title, description, variant = "default", duration = 3000 } = props;

        // Combine title and description into a single message
        const message = title && description ? `${title}: ${description}` : title || description || "";

        if (variant === "destructive") {
            sonnerToast.error(message, { duration });
        } else {
            sonnerToast.success(message, { duration });
        }
    }, []);

    return { toast };
};
